<template>
  <b-modal
    id="deleteLink"
    ref="deleteLinkModal"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    title="Suppression des liens"
    :modal-class="'base-modal'"
    :lazy="true"
    @hide="handleClose"
  >
    <b-container fluid>
      <div class="text-edit">
        <template v-if="this.currentShapeLink.length">
          <h2 class="sub-title">Choix des liens</h2>
          <p class="info">
            Veuillez sélectionner les liens de données à supprimer.
          </p>
          <b-form-group>
            <b-form-checkbox v-model="allSelected" @change="toggleAll()">
              {{ allSelected ? "Tout déselectionner" : "Tout sélectionner" }}
            </b-form-checkbox>
            <hr />
            <b-form-checkbox-group
              v-model="selection"
              :options="options"
              name="fiches-espaces"
              stacked
            ></b-form-checkbox-group>
          </b-form-group>
        </template>
        <template v-else>
          <h2 class="sub-title">Choix des liens</h2>
          <p class="info text-info">
            Vous n'avez actuellement aucune données liées à cette forme.
          </p>
        </template>
      </div>
    </b-container>
    <div slot="modal-footer" class="w-100">
      <div class="footer-action float-right">
        <b-button
          variant="outline-primary"
          size="md"
          class="mx-2"
          @click="handleClose"
        >
          Annuler
        </b-button>
        <b-button
          variant="primary"
          size="md"
          :disabled="!selection.length"
          @click="handleDeleteLink"
        >
          Supprimer
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import dataFilterContainer from '../dataFilterContainer'
export default {
  components: {
    dataFilterContainer
  },
  data () {
    return {
      selection: [],
      currentShapeId: null,
      currentShapeLink: [],
      options: null,
      allSelected: false
    }
  },
  watch: {
    selection: {
      handler (val) {
        this.allSelected = val.length === this.options.length
      },
      deep: true
    }
  },
  methods: {
    handleClose () {
      this.selection = []
      this.$emit('close')
      this.$refs['deleteLinkModal'].hide()
    },
    open (shapeLinks) {
      this.currentShapeLink = shapeLinks
      this.options = this.currentShapeLink.map(el => {
        return {
          text: `${el.title}: ${el.data}`,
          value: el.id
        }
      })
      this.$nextTick().then(() => {
        this.$refs['deleteLinkModal'].show()
      })
    },
    handleDeleteLink () {
      this.$emit('deleteLink', {selection: this.selection, all: this.allSelected })
      this.handleClose()
    },
    handleSelect (id, type) {
      this.$emit('selected', id, type)
    },
    handleMultiSelect (values) {
      this.selection = values
    },
    toggleAll () {
      this.selection = !this.allSelected ? this.options.map(el => (el.value)) : []
    }

  }
}
</script>

<style lang="scss" scoped>
.text-edit {
  margin-top: 20px;
  width: 100%;
  p.info {
    font-style: italic;
    color: rgba(0, 0, 0, 0.5);
    font-size: 13px;
    text-align: left;
  }
  h2.sub-title {
    margin-top: 30px;
    font-size: 16px;
    font-weight: 600;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/schemaFonctionnel/modal/deleteLinkModal.vue